import React from 'react';
import { Box, Link, LinkProps, SxProps, Theme } from '@mui/material';

type ResourceLinkProps = LinkProps & {
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
};

export default function ResourceLink({
  startIcon,
  endIcon,
  sx,
  children,
  target,
  rel,
  ...props
}: ResourceLinkProps) {
  const mergedSx: SxProps<Theme> = [
    {
      display: 'inline-flex',
      alignItems: 'center',
      gap: 0.75,
      width: 'fit-content',
      color: '#39ff14',
      fontWeight: 700,
      textDecorationColor: 'rgba(57, 255, 20, 0.55)',
      textUnderlineOffset: '4px',
      '&:hover': {
        color: '#8dff7a',
        textDecorationColor: '#8dff7a',
      },
      '&:focus-visible': {
        outline: '2px solid #39ff14',
        outlineOffset: 3,
        borderRadius: 1,
      },
    },
    ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
  ];

  return (
    <Link
      data-resource-link="true"
      target={target}
      rel={target === '_blank' ? rel || 'noreferrer' : rel}
      sx={mergedSx}
      {...props}
    >
      {startIcon && <Box component="span" sx={{ display: 'inline-flex' }}>{startIcon}</Box>}
      <Box component="span">{children}</Box>
      {endIcon && <Box component="span" sx={{ display: 'inline-flex' }}>{endIcon}</Box>}
    </Link>
  );
}
